import './style.css';

function Header() {

  return (
    <div className='header-content'>
      <h1>CodeLeap Network</h1>
    </div>
  )

}

export default Header;
